/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa forms
 *
 */
Intesa.Survey = function() {

	function recaptchaCallback() {
		$("#recaptchainput").val('true');
			setTimeout(function(){
				$('form[name="formThanksMortgage"]').parsley().validate();
				survey.checkPrivacy();
			},500);
	}
	
	function validationCallback() {
		setTimeout(function () {
			$('form[name="formThanksMortgage"]').parsley().validate();
			forms.checkPrivacy();
		}, 500);
	}

	/**
	 * Local variables
	 *
	 */
	var survey = this;

	/**
	 * Init component
	 *
	 */
	 
	  var isCIB = $('html').attr('data-bank') == 'CIB';
	 
	this.init = function () {
		
		// TODO: controllami
		 console.log("is CIB " + isCIB);
		 if(!isCIB)
			  return;

		survey.attachOpenMortgageFormEvent();

		window.recaptchaCallback = $("input[name='recaptchaKey']").length >= 1 ? validationCallback : recaptchaCallback;


		survey.sessionMortage = [{"form1": {
		        "basicQuestionsOne": "",
		        "basicQuestionsTwo": "",
		        "basicQuestionsThree": "",
		        "basicQuestionsFour": "",
				"basicQuestionsFive": "",
				"installment": "",
				"tenor": "",
				"loanAmount": "",
				"productId": "",
				"productName": "",
				"interestRate": "",
				"interestPeriod": "",
		        "loanPurpose": ""
		    },"form2": {
		        "debitorIncomeOne": "",
		        "debitorIncomeTwo": "",
		        "debitorIncomeThree": "",
		        "debitorIncomeFour": "",
		        "installmentExistingsLoan": "",
		        "existingCreditCardLimit": "",
		        "existingOverdraftLimit": "",
		        "otherDeductionsExpenses": "",
		        "cashLoan": "",
		        "babyLoan": ""
		    },"form3": {
		        "collateralOne": "",
		        "locatedOne": "",
		        "collateralTwo": "",
		        "locatedTwo": "",
		        "collateralThree": "",
		        "locatedThree": ""
		    }}];

		var sessionJSON = sessionStorage.getItem('mortageJSON') || '';
		if(sessionJSON.length > 0) {
			var JSON_Obj = JSON.parse(sessionJSON);
			survey.sessionMortage = JSON_Obj;
		}
		
		//THE FUNCTION SHOW MODALE IS STILL USED IN THE FUNCIONS.JS, SO WE DISABLED IT TO CALL IT JUST ONE TIME
		//survey.showModale();
		// survey.callServletTrigger();

		if($('[data-component-r="survey_loan"]').length > 0) {
			console.log("start");
			survey.refreshSteps(1);
			survey.toggleAccordione();
			survey.formSteps1Mortagage();
			survey.setActiveInputs();
			survey.setActiveImports();
			survey.stepsByStorage();
			survey.goNext();
			survey.goBackSteps();
			// survey.plusMinuso();
			survey.showHidLoan();
			survey.showMessageErrore(1);
			if($("#privacystatus").length>0){
				survey.checkPrivacy();
			}
		}

	};

	/* --------------------- */

	this.stepsByStorage = function() {
		var sessionJSON = sessionStorage.getItem('mortageJSON') || '';
		if(sessionJSON.length > 0) {
			var JSON_Obj = JSON.parse(sessionJSON);

		    if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
			    for (var key in JSON_Obj[0].form1) {
							if (key == "installment" || key == "tenor" || key == "loanAmount" || key == "productId" || key == "productName" || key == "interestRate" || key == "interestPeriod" || key == "loanPurpose" ) continue;
			        if($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form1[key].length > 0) {
			        	showStep(key);
			            $('input[name="' + key + '"]').each(function() {
			                var self = this;
			                if($(self).val() == JSON_Obj[0].form1[key]) {
			                    $(self).attr('checked', true).parent('label').trigger('click');
			                }
			            });
			        }
			    }
			}

			if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
			    for (var key in JSON_Obj[0].form2) {
			        if($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form2[key].length > 0) {
			        	$('input[name="' + key + '"]').val(JSON_Obj[0].form2[key]);

		            	var stepNumber = parseInt(survey.getStep());
		            	$(".rstepwrapper").eq(stepNumber-1).find('input[name="' + key + '"]').trigger("keyup");

			            if(key == 'debitorIncomeOne') {
			            	$('.rstep1 .rvalue-increase').text(1);
			            	$(".rstepwrapper").eq(0).find(".mod-hom1").eq(0).removeClass("rhide");
			            }
			            if(key == 'debitorIncomeTwo') {
			            	$('.rstep1 .rvalue-increase').text(2);
			            	$(".rstepwrapper").eq(0).find(".mod-hom1").eq(1).removeClass("rhide");
			            }
			            if(key == 'debitorIncomeThree') {
			            	$('.rstep1 .rvalue-increase').text(3);
			            	$(".rstepwrapper").eq(0).find(".mod-hom1").eq(2).removeClass("rhide");
			            }
			            if(key == 'debitorIncomeFour') {
			            	$('.rstep1 .rvalue-increase').text(4);
			            	$(".rstepwrapper").eq(0).find(".mod-hom1").eq(3).removeClass("rhide");
			            }

			            $('.rstepwrapper').addClass('rhide');

			        	switch(key) {
			            	case 'debitorIncomeOne':
			            	case 'debitorIncomeTwo':
			            	case 'debitorIncomeThree':
			            	case 'debitorIncomeFour':
			            		survey.setStep(1);
			            		survey.refreshSteps(1);
			            		$('.rstep1').removeClass('rhide');
			            		break;
			            	case 'installmentExistingsLoan':
			            		survey.setStep(2);
			            		survey.refreshSteps(2);
			            		$('.rstep2').removeClass('rhide');
			            		break;
			            	case 'existingCreditCardLimit':
			            		survey.setStep(3);
			            		survey.refreshSteps(3);
			            		$('.rstep3').removeClass('rhide');
			            		break;
			            	case 'existingOverdraftLimit':
			            		survey.setStep(4);
			            		survey.refreshSteps(4);
			            		$('.rstep4').removeClass('rhide');
			            		break;
			            	case 'otherDeductionsExpenses':
			            		survey.setStep(5);
			            		survey.refreshSteps(5);
			            		$('.rstep5').removeClass('rhide');
			            		break;
			            	case 'cashLoan':
			            	case 'babyLoan':
			            		survey.setStep(6);
			            		survey.refreshSteps(6);
			            		$('.rstep6').removeClass('rhide');
			            		$('input[name="step2Questions"]').each(function() {
													var self = this;
					                if($(self).val() == 'yes') {
					                    $(self).attr('checked', true).parent('label').addClass('active');
					                }
			            		});
			            		break;
			            	default:
			            		survey.setStep(1);
			            }
			        }
			    }
			}

			if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
				for (var key in JSON_Obj[0].form3) {
					if($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form3[key].length > 0) {
			            $('input[name="' + key + '"]').val(JSON_Obj[0].form3[key]).trigger('focus');
			            $('input[name="' + key + '"]').val(JSON_Obj[0].form3[key]).trigger("keyup");
			            if(key == 'collateralOne') {
			            	$('.rstep1 .rvalue-increase').text(1);
			            	var curstepwrapper = $(".rstepwrapper").eq(0);
							curstepwrapper.find(".mod-hom1").eq(0).removeClass("rhide");
			            }
			            if(key == 'collateralTwo') {
			            	$('.rstep1 .rvalue-increase').text(2);
			            	var curstepwrapper = $(".rstepwrapper").eq(0);
							curstepwrapper.find(".mod-hom1").eq(1).removeClass("rhide");
			            }
			            if(key == 'collateralThree') {
			            	$('.rstep1 .rvalue-increase').text(3);
			            	var curstepwrapper = $(".rstepwrapper").eq(0);
							curstepwrapper.find(".mod-hom1").eq(2).removeClass("rhide");
			            }
			            survey.setStep(1);
	            		survey.refreshSteps(1);
	            		$('.rstep1').removeClass('rhide');
			        }
			    }
			}
		}

	    function showStep(key_obj) {
	        $('.rstepwrapper').addClass('rhide');

	        if(key_obj.indexOf('One') > -1) {
	            $('.rstep1').removeClass('rhide');
	            survey.setStep(1);
	            survey.refreshSteps(1);
	        }
	        if(key_obj.indexOf('Two') > -1) {
	            $('.rstep2').removeClass('rhide');
	            survey.setStep(2);
	            survey.refreshSteps(2);
	        }
	        if(key_obj.indexOf('Three') > -1) {
	            $('.rstep3').removeClass('rhide');
	            survey.setStep(3);
	            survey.refreshSteps(3);
	        }
	        if(key_obj.indexOf('Four') > -1) {
	            $('.rstep4').removeClass('rhide');
	            survey.setStep(4);
	            survey.refreshSteps(4);
	        }
	        if(key_obj.indexOf('Five') > -1) {
	            $('.rstep5').removeClass('rhide');
	            survey.setStep(5);
	            survey.refreshSteps(5);
	        }
	    }
	}

	this.goNext = function() {
		$(document).on('click', 'button.r-btn-avanti', function(e) {

			e.preventDefault();
			var self = $(this);
			var stepNumber = parseInt(survey.getStep());
			var dataStepNew = parseInt(self.attr('data-step')) + 1;

			var myForm = $('input[name="myForm"]').val();

			// if(myForm == 'form2') {
			// 	if($("[name='step2Questions']:checked").val()=="no"){
			// 		survey.sessionMortage[0].form2.cashLoan = '';
			// 		survey.sessionMortage[0].form2.babyLoan = '';
			// 	}
			// }

			sessionStorage.setItem('mortageJSON', JSON.stringify(survey.sessionMortage));

			if(myForm == 'form1') {
				sessionStorage.setItem('mortageStep', '1');
			}
			// if(myForm == 'form2') {
			// 	sessionStorage.setItem('mortageStep', '2');
			// }
			// if(myForm == 'form3') {
			// 	sessionStorage.setItem('mortageStep', '3');
			// }

			if(dataStepNew > $("#numberofsteps").val()) {
				var myForm = $('input[name="myForm"]').val();

				var sessionStorageMortage = sessionStorage.getItem('mortageJSON');
				if(sessionStorageMortage.length > 0) {
					var JSON_Obj = JSON.parse(sessionStorageMortage);
				}

				if(myForm == 'form1') {
					if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
					    for (var key in JSON_Obj[0].form1) {
					        if(JSON_Obj[0].form1[key].length > 0) {
					        	$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
					        } else if(key == 'installment' || key == 'loanAmount' || key == 'tenor' || key == 'interestPeriod' || key == 'interestRate' || key == 'productName' || key == 'productId' || key == 'loanPurpose') {
					        	$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
					        }
					    }
					}
				}
				if(myForm == 'form2') {
					if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
					    for (var key in JSON_Obj[0].form1) {
					        if(JSON_Obj[0].form1[key].length > 0) {
					        	$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
					        }
					    }
					}
					if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
					    for (var key in JSON_Obj[0].form2) {
					        if(JSON_Obj[0].form2[key].length > 0) {
					        	$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
					        } else {
					        	$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
					        }
					    }
					}

				}
				if(myForm == 'form3') {
					if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
					    for (var key in JSON_Obj[0].form1) {
					        if(JSON_Obj[0].form1[key].length > 0) {
					        	$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
					        }
					    }
					}
					if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
					    for (var key in JSON_Obj[0].form2) {
					        if(JSON_Obj[0].form2[key].length > 0) {
					        	$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
					        } else {
					        	$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
					        }
					    }
					}
					if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
					    for (var key in JSON_Obj[0].form3) {
					        if(JSON_Obj[0].form3[key].length > 0) {
					        	$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
					        } else {
					        	$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
					        }
					    }
					}
				}

				$('form#formTemp').submit();
			} else {
				survey.disableNext($('button.r-btn-avanti'));

				var myForm = $('input[name="myForm"]').val();

				if(myForm == 'form1') {
					
					setTimeout(function(){
						console.log(dataStepNew); 
						if($(".rstepwrapper").eq(dataStepNew-1).find('input[data-ok]:checked').length > 0) {

							$(".rstepwrapper").eq(dataStepNew-1).find('input[data-ok]:checked').parent('.rcontainer-input').trigger('click');

						} else{

							survey.disableNext(self);

						}

					}, 10);

				}

				survey.refreshSteps(dataStepNew);
				survey.setStep(dataStepNew);

				$('.rstepwrapper').addClass('rhide');
				$('.rstepwrapper').eq(dataStepNew-1).removeClass('rhide');
			}

			survey.showHidLoan();
			survey.scrollToTop();
			
			
			if(dataStepNew > $("#numberofsteps").val()){
				window.location.replace($("#submit").attr("data-redirect"));
			}

		});
	};

	//scroll to top
	this.scrollToTop = function() {
		var xtop = 150;
		var x = $(".r-form-top-section").position()||"";
		if (x!==""){
			xtop = x.top;
		}
		$('html, body').animate({scrollTop:xtop},'500');
	}

	if ($(".r-form-top-section").length>0){
		survey.scrollToTop();
	}


	this.goBackSteps = function() {
		$(document).on('click', 'button.r-btn-indietro', function(e) {

			e.preventDefault();
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var myForm = $('input[name="myForm"]').val();

			if(dataStepNew < 1) {
				var gotoform = "";
				var mortageForm = localStorage.getItem('mortageForm') || "";
				if (mortageForm!==""){
					mortageForm = JSON.parse(mortageForm);
					if(myForm == 'form1') {gotoform = mortageForm.form1}
					if(myForm == 'form2') {gotoform = mortageForm.form2}
					if(myForm == 'form3') {gotoform = mortageForm.form3}
					if (gotoform!==""){
						window.location.href=gotoform;
					}
				}

				//history.back(1);
			} else {

				survey.disableNext($('button.r-btn-avanti'));


				if(myForm == 'form1') {
					setTimeout(function(){

						if($(".rstepwrapper").eq(dataStepNew-1).find('input[data-ok]:checked').length > 0) {

							$(".rstepwrapper").eq(dataStepNew-1).find('input[data-ok]:checked').parent('.rcontainer-input').trigger('click');

						} else{

							survey.disableNext($('button.r-btn-avanti'));

						}

					}, 10);
				}

				if(myForm == 'form2') {

					setTimeout(function(){

						if($(".rstepwrapper").eq(dataStepNew-1).find('input').val().length > 0) {

							$(".rstepwrapper").eq(dataStepNew-1).find('input').each(function() {
								var self = $(this);
								if(self.is(':visible')) {
									self.trigger("keyup");
								}
							});

						} else {

							survey.disableNext($('button.r-btn-avanti'));

						}

					}, 10);

				}

				survey.refreshSteps(dataStepNew);
				survey.setStep(dataStepNew);

				$('.rstepwrapper').addClass('rhide');
				$('.rstepwrapper').eq(dataStepNew-1).removeClass('rhide');
			}

			survey.showHidLoan();
			survey.scrollToTop();

		});
	}

	this.formSteps1Mortagage = function() {

		survey.setStep(1);//schiantato

	}

	//set active input
	this.setActiveInputs = function() {
		$(".rcontainer-input").on("click",function(){
			var name = $(this).find('input').attr("name");
			$('[name='+name+']').parent().removeClass("active");
			$(this).addClass("active");

			var myForm = $('input[name="myForm"]').val();

			if(myForm == 'form1') {
				var stepNumber = parseInt(survey.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber-1).find("input[data-ok]").is(":checked");
				if(chekToInput) survey.sessionMortage[0].form1[name] = $('[name='+name+']:checked').val();
			}

			survey.showMessageErrore(survey.getStep());
		});

	}

	this.setActiveImports = function() {
		$(".rcontainer-import input").on("keyup", function() {
			var self = $(this);
			if(self.val().length > 0) {
				if((self.attr("name")=="babyLoan")||(self.attr("name")=="cashLoan")){
					if(($("[name=cashLoan]").val().length>0)&&($("[name=babyLoan]").val().length>0)){
						survey.setActiveNext($('button.r-btn-avanti'));
					} else {
						survey.disableNext($('button.r-btn-avanti'));
					}
				} else{
					survey.setActiveNext($('button.r-btn-avanti'));
				}

				if($(".rstepwrapper").eq(parseInt(survey.getStep())-1).find("input").length > 1 && $(".rstepwrapper").eq(parseInt(survey.getStep())-1).find('.rcontainer-import').attr('data-showHidLoan') == undefined) {
					$(".rstepwrapper").eq(parseInt(survey.getStep())-1).find("input").each(function() {
						if($(this).is(':visible') && $(this).val() == '') {
							survey.disableNext($('button.r-btn-avanti'));
							return;
						}
					});
				}

				var name = $(this).attr("name");
				var myForm = $('input[name="myForm"]').val();

				if(myForm == 'form2') {
					survey.sessionMortage[0].form2[name] = $('[name='+name+']').val().replace(/ /g, '');
				}

				if(myForm == 'form3') {
					survey.sessionMortage[0].form3[name] = $('[name='+name+']').val().replace(/ /g, '');
				}
			} else {
				survey.disableNext($('button.r-btn-avanti'));
			}
		});
	}

	//refresh the step progress
	this.refreshSteps = function(step) {
		var totalSteps = $("#numberofsteps").val()||"5";
		if ((step!==null)&&(step!=="")&&(step!==undefined)){
			$(".r-cur-step").text(step);
			if ((totalSteps!==null)&&(totalSteps!=="")&&(totalSteps!==undefined)){
				$(".r-tot-step").text(totalSteps);
				$(".r-progress-bar-fill").width(parseInt(step)/parseInt(totalSteps)*100+"%");
			}
		}
	}

	//set button next active
	this.setActiveNext = function(thisBtn) {
		thisBtn.addClass("active").prop("disabled", false);
	}

	//disable button next
	this.disableNext = function(thisBtn) {
		thisBtn.removeClass("active").prop("disabled", true);
	}
	
	
	

	//get the current step number
	this.getStep = function() {

		var stepNumber = $('button.r-btn-avanti').attr('data-step');
		return stepNumber;

	}
	

	
	//show the error msg
	this.showMessageErrore = function(stepNumber) {
		console.log(stepNumber);
		if(stepNumber == 1){
			console.log("back disabilitato step1");
			$('button.r-btn-indietro').removeClass("active").prop("disabled", true);
		}
		$( "button.r-btn-avanti" ).on( "click", function() {
				console.log( "Click e abilito" );
				$('button.r-btn-indietro').addClass("active").prop("disabled", false);
			});
		
			
		survey.disableNext($('button.r-btn-avanti'));

		console.log("error-msg");
		stepNumber = parseInt(stepNumber);
		var curstepwrapperNo = $(".rstepwrapper").eq(stepNumber-1).find('[value="no"]').is(":checked");
		var curstepwrapperYes = $(".rstepwrapper").eq(stepNumber-1).find('[value="yes"]').is(":checked");

		if (curstepwrapperNo) {
			console.log("No");
		$(".rstepwrapper").eq(stepNumber-1).find(".col-md-24").removeClass('hide-error-message'); 
			console.log("disable next");
			survey.disableNext($('button.r-btn-avanti'));
		} else if (curstepwrapperYes) {
			console.log("Yes");
		$(".rstepwrapper").eq(stepNumber-1).find(".col-md-24").addClass('hide-error-message'); 
			console.log("active next");
			survey.setActiveNext($('button.r-btn-avanti'));
		}
	}
	

	
	//set the current step number
	this.setStep = function(stepNumber) {
		$(".r-form-submit-wrapper button").attr("data-step",stepNumber);
		survey.refreshSteps(stepNumber);
	}

	//toggle form accordion
	this.toggleAccordione = function() {

		$('[data-accordion="title"]').on("click",function(){

			$(this).addClass("rhide");
			$(this).next('[data-accordion="detail"]').removeClass("rhide");

		});

		$('[data-accordion="detail"] .rtitle-accordotion').on("click",function(){

			$(this).parent().addClass("rhide");
			$(this).parent().prev('[data-accordion="title"]').removeClass("rhide");

		});

	}

	// plus minus
	// this.plusMinuso = function(val) {

	// 	if ($("[data-plusMinuso]").length>0){

	// 		$("[data-plusMinuso]").each(function(){


	// 			if ((val!==null) && (val!==undefined) && (val!=="")){
	// 				$(this).find("[data-val]").text(val);
	// 			}

	// 			var thisMax = $(this).attr("data-maximum");
	// 			var curVal = $(this).find("[data-val]").text();
	// 			var thisMinus = $(this).find("[data-minus]");
	// 			var thisPlus = $(this).find("[data-plus]");

	// 			thisMinus.removeClass("disabled");
	// 			thisPlus.removeClass("disabled");
	// 			if (curVal=="0"){
	// 				thisMinus.addClass("disabled");
	// 				survey.disableNext($('button.r-btn-avanti'));
	// 			}

	// 			if (curVal==thisMax){
	// 				thisPlus.addClass("disabled");
	// 			}

	// 		});

	// 	}

	// }

	//Open form mortgage
	this.attachOpenMortgageFormEvent = function(){
		$("[data-openmortgageform]").on("click",function(){

			survey.getInputs(this);

			//var form1lnk = $(this).attr("data-openmortgageform")||"";
			var form1lnk = window.location.pathname;
			var form2lnk = $(this).attr("data-openmortgageform")||"";
			var form3lnk = $(this).attr("data-openmortgageform2")||"";
			var mortageFormOBJ = {"form1": form1lnk, "form2": form2lnk, "form3": form3lnk};
			mortageFormJSON = JSON.stringify(mortageFormOBJ);
			if ($(this).attr("href") == "" || $(this).attr("href") == "#") {
				localStorage.setItem('mortageForm', mortageFormJSON);
			}

			var mortageStep = sessionStorage.getItem('mortageStep') || "";
			if(mortageStep !== "") {
				if(mortageStep == "2") {
						window.location.href=$(this).attr("data-openmortgageform2");
				}
				if(mortageStep == "3") {
						window.location.href=$(this).attr("data-openmortgageform3");
				}
				if((mortageStep !== "2")&&(mortageStep !== "3")) {
						window.location.href=$(this).attr("data-openmortgageform");
				}
			} else{
				if($(this).attr("href") == "" || $(this).attr("href") == "#"){
					window.location.href=$(this).attr("data-openmortgageform");
				}
			}

			return false;

		});
	}

	//get inputs for the form
	this.getInputs = function(element) {

		if ($('[data-active-tab="withsalary"]').hasClass("open")){ //if is promo

			var installment = ""+window.intesa.mortgage_calculator.monthlyInstallmentValuePromo || "";
			var interestRate = ""+window.intesa.mortgage_calculator.interestRateResultPromo || "";

		} else{

			var installment = ""+window.intesa.mortgage_calculator.monthlyInstallmentValueStandard || "";
			var interestRate = ""+window.intesa.mortgage_calculator.interestRateResultStandard || "";

		}

		var activeCalculator = $(element).parents("section[data-calculator]");

		var tenor = ""+window.intesa.mortgage_calculator.tenorValue || "";
		var loanAmount = ""+window.intesa.mortgage_calculator.borrowAmountValue || "";
		var productName = $("[name=fProductName]", activeCalculator).val() || "";
		var productId = $("[name=fProductId]", activeCalculator).val() || "";
		var interestPeriod = $("[name=fInterestPeriod]", activeCalculator).val() || "";
		var loanPurpose = $("[name=fLoanPurpose]", activeCalculator).val() || "";

		survey.sessionMortage[0].form1.loanAmount = loanAmount||'';
		survey.sessionMortage[0].form1.installment = installment||'';
		survey.sessionMortage[0].form1.tenor = tenor||'';
		survey.sessionMortage[0].form1.productId = productId||'';
		survey.sessionMortage[0].form1.productName = productName||'';
		survey.sessionMortage[0].form1.interestRate = interestRate||'';
		survey.sessionMortage[0].form1.interestPeriod = interestPeriod||'';
		survey.sessionMortage[0].form1.loanPurpose = loanPurpose||'';

		sessionStorage.setItem('mortageJSON', JSON.stringify(survey.sessionMortage));

	}

	//show hide elements
	this.showHideElements = function(val) {

		if ((val!==null) && (val!==undefined) && (val!=="")){

			var stepNumber = survey.getStep();
			var curstepwrapper = $(".rstepwrapper").eq(stepNumber-1);
			curstepwrapper.find(".mod-hom1").addClass("rhide");
			val = parseInt(val);

			for (i=0;i<=val-1;i++){
				curstepwrapper.find(".mod-hom1").eq(i).removeClass("rhide");
			}

			if(val > 0) survey.setActiveNext($('button.r-btn-avanti'));
			if($(".rstepwrapper").eq(parseInt(survey.getStep())-1).find("input").length > 1) {
				$(".rstepwrapper").eq(parseInt(survey.getStep())-1).find("input").each(function() {
					if(($(this).is(':visible') && $(this).val() == '')) {
						survey.disableNext($('button.r-btn-avanti'));
						return;
					}
				});
			}

		}

	}

	this.resetForms2 = function(thisVal) {
		if(parseInt(thisVal)-1 == 0) {
			$('input[name="debitorIncomeOne"]').val('');
			survey.sessionMortage[0].form2.debitorIncomeOne="";
		}
		if(parseInt(thisVal)-1 == 1) {
			$('input[name="debitorIncomeTwo"]').val('');
			survey.sessionMortage[0].form2.debitorIncomeTwo="";
		}
		if(parseInt(thisVal)-1 == 2) {
			$('input[name="debitorIncomeThree"]').val('');
			survey.sessionMortage[0].form2.debitorIncomeThree="";
		}
		if(parseInt(thisVal)-1 == 3) {
			$('input[name="debitorIncomeFour"]').val('');
			survey.sessionMortage[0].form2.debitorIncomeFour="";
		}
	}

	this.resetForms3 = function(thisVal) {
		if(parseInt(thisVal)-1 == 0) {
			$('input[name="collateralOne"]').val('');
			$('input[name="locatedOne"]').val('');
			survey.sessionMortage[0].form3.collateralOne="";
			survey.sessionMortage[0].form3.locatedOne="";
		}
		if(parseInt(thisVal)-1 == 1) {
			$('input[name="collateralTwo"]').val('');
			$('input[name="locatedTwo"]').val('');
			survey.sessionMortage[0].form3.collateralTwo="";
			survey.sessionMortage[0].form3.locatedTwo="";
		}
		if(parseInt(thisVal)-1 == 2) {
			$('input[name="collateralThree"]').val('');
			$('input[name="locatedThree"]').val('');
			survey.sessionMortage[0].form3.collateralThree="";
			survey.sessionMortage[0].form3.locatedThree="";
		}
	}

	//decrease Value
	// $("[data-minus]").on("click",function(){

	// 	var thisCounter = $(this).next("[data-val]");
	// 	var thisVal = thisCounter.text();
	// 	if (!$(this).hasClass("disabled")){
	// 		thisCounter.text(parseInt(thisVal)-1);
	// 		survey.plusMinuso(parseInt(thisVal)-1);

	// 		survey.showHideElements(parseInt(thisVal)-1);

 	// 		if($('input[name="debitorIncomeOne"]').length > 0) {
 	// 			survey.resetForms2(thisVal);
 	// 		}

 	// 		if($('input[name="collateralOne"]').length > 0) {
 	// 			survey.resetForms3(thisVal);
 	// 		}

	// 	}

	// });

	//show/hide loan form2
	$("[data-showloan]").on("click",function(){
		$("[data-showHidLoan]").removeClass("rhide");
	});
	$("[data-hideloan]").on("click",function(){
		$("[data-showHidLoan]").addClass("rhide").find("input").val("");
	});

	this.showHidLoan = function() {

		if ($("[data-showloan]").is(":checked")){
			$("[data-showHidLoan]").removeClass("rhide");
		} else{
			$("[data-showHidLoan]").addClass("rhide").find("input").val("");
		}

	}

	//increase Value
	// $("[data-plus]").on("click",function(){

	// 	var thisCounter = $(this).prev("[data-val]");
	// 	var thisVal = thisCounter.text();
	// 	if (!$(this).hasClass("disabled")){
	// 		thisCounter.text(parseInt(thisVal)+1);
	// 		survey.plusMinuso(parseInt(thisVal)+1);

	// 		survey.showHideElements(parseInt(thisVal)+1);

	// 		if(parseInt(thisVal)+1 == 1) {
	// 			$('input[name="debitorIncomeOne"]').trigger('keyup');
	// 		}
	// 		if(parseInt(thisVal)+1 == 2) {
	// 			$('input[name="debitorIncomeTwo"]').trigger('keyup');
	// 		}
	// 		if(parseInt(thisVal)+1 == 3) {
	// 			$('input[name="debitorIncomeThree"]').trigger('keyup');
	// 		}
	// 		if(parseInt(thisVal)+1 == 4) {
	// 			$('input[name="debitorIncomeFour"]').trigger('keyup');
	// 		}
	// 	}

	// });

	//set selected label as active
	$(".r-thankyou-time label").on("click",function(){
		$(".r-thankyou-time label").removeClass("active");
		$(this).addClass("active");
	});

	//accept only numbers
  $(document).on("input",".r-thankyou-wrapper [name='prefixNumber'], .r-thankyou-wrapper [name='phoneNumber']",function(e){
      $(this).val($(this).val().replace(/[^0-9]/g, ''));//allow only numbers
  });

	//check success form privacy status
	this.checkPrivacy = function() {
		var item_thanksName = "none";
		if ($("#item_thanksName").length>0){
			item_thanksName = $("#item_thanksName").val();
		}
		var thanksLastname = "none";
		if ($("#item_thanksLastname").length>0){
			thanksLastname = $("#item_thanksLastname").val();
		}
		var checkCaptcha = $("input[name='recaptchaKey']").length >= 1 || "" != $(".g-recaptcha-response").val() ? true : false;
		if(($("#privacystatus").is(":checked"))&&($("#item_email").val()!=="")&&(item_thanksName!=="")&&(thanksLastname!=="")
			&&($('[name="prefixNumber"]').val()!=="")&&($('[name="phoneNumber"]').val()!=="")
			&&(checkCaptcha)){
				$(".r-thankyou-wrapper .j-privacy__btn").prop("disabled", false);
		} else{
			$(".r-thankyou-wrapper .j-privacy__btn").prop("disabled", true);
		}
	}


	//change btn status after privacy changes
	$("#privacystatus").on("click",function(){

		survey.checkPrivacy();

	});

	$(".r-thankyou-wrapper input").on("change input",function(e){
		survey.checkPrivacy();
	});

	//validate on focus out
	$('.r-thankyou-content input[required]').on("focusout blur",function(){
		$(this).parsley().validate();
	});


	//submit form success
	// $(".r-thankyou-wrapper .j-privacy__btn").on("click",function(e){

	// 	e.preventDefault();

	// 	//check parsley first
	// 	var isformok = $('form[name="formThanksMortgage"]').parsley().validate();
	// 	if (isformok){

	// 		// get all the inputs into an array.
	// 		var $inputs = $('.r-thankyou-content :input');

	// 		$inputs.each(function() {

	// 			if( $(this).attr('name')!==undefined ){

	// 				var vall = $(this).val() || "";
	// 				var namee = $(this).attr('name') || "";

	// 				if( namee=="privacystatus" ){
	// 					if($(this).is(":checked") ){
	// 						vall = "true";
	// 					} else{
	// 						vall = "false";
	// 					}
	// 				}

	// 				if ( namee=="radioTime") {
	// 					if( $(this).is(":checked")){
	// 						$("form#formTemp").find("input[name="+$(this).attr('name')+"]").remove();
	// 						$("form#formTemp").append('<input type="hidden" name="' + $(this).attr('name') + '" value="' + vall + '"/>');
	// 					} else{
	// 						//
	// 					}
	// 					//
	// 				} else{
	// 					$("form#formTemp").find("input[name="+$(this).attr('name')+"]").remove();
	// 					$("form#formTemp").append('<input type="hidden" name="' + $(this).attr('name') + '" value="' + vall + '"/>');
	// 				}

	// 			}


	// 		});


	// 		var sessionStorageMortage = sessionStorage.getItem('mortageJSON') || "";
	// 		if(sessionStorageMortage !== "") {
	// 			if(sessionStorageMortage.length > 0) {
	// 				var JSON_Obj = JSON.parse(sessionStorageMortage);
	// 			}
	// 		}

	// 		if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
	// 			for (var key in JSON_Obj[0].form1) {
	// 				if(JSON_Obj[0].form1[key].length > 0) {
	// 					$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
	// 				}
	// 			}
	// 		}
	// 		if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
	// 			for (var key in JSON_Obj[0].form2) {
	// 				if(JSON_Obj[0].form2[key].length > 0) {
	// 					$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
	// 					console.log("sono in survey")
	// 				} else {
	// 					$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
	// 				}
	// 			}
	// 		}
	// 		if(JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
	// 			for (var key in JSON_Obj[0].form3) {
	// 				if(JSON_Obj[0].form3[key].length > 0) {
	// 					$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
	// 					console.log("sono in survey")
	// 				} else {
	// 					$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
	// 				}
	// 			}
	// 		}

	// 		$('form#formTemp').submit();

	// 	}

	// 	return false;


	// });

	//delete sessionstorage if form is successfully sent
	if ($("[data-formsent]").length>0){
		sessionStorage.removeItem('mortageJSON');
		sessionStorage.removeItem('mortageStep');
	}

	//on resize, reset the wallpaper
	function resizedw(){
		if($("[data-bgimg]").length>0){
			$("[data-bgimg]").each(function(){
				var imageUrl = $(this).attr("data-bgimg");
				$(this).css('background-image', 'url(' + imageUrl + ')');
			});
		}
	}

	var doit;
	window.onresize = function(){
	  clearTimeout(doit);
	  doit = setTimeout(resizedw, 100);
	};

	




	/**
	 * Show modal
	 *
	 */
	this.showModale = function() {

		if( $( "[data-show-modal]" ).length ) {

			$( "[data-show-modal]" ).each( function( index, el ) {

				if( $( this ).attr( "data-show-modal" ) == "true" ) {

					var modalName = $( this ).attr( "id" );
					$("[data-bs-target='#" + modalName + "']").get(0).click();
    				$("#" + modalName).addClass("in");

				}

			} );

		}

	};

};

/**
 * Get class instance
 *
 */
 Intesa.Survey.getInstance = function() {

	if( !window.intesa ) {

		window.intesa = new Object();

	}
	if( !window.intesa.survey ) {

		window.intesa.survey = new Intesa.Survey();

	}

	return window.intesa.survey;

};

/**
 * On DOM ready
 *
 */
// $( document ).ready( function() {
/* document.addEventListener( "DOMContentLoaded", function() {

	// init component
	var forms = Intesa.survey.getInstance();
	survey.init();

} ); */